
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'

import KeyCode from '@/shared/enums/KeyCode'

@Component
export default class Modal extends Vue {
  @Prop({ required: true }) readonly show!: boolean
  @Prop({ default: 0 }) width!: number
  @Prop({ default: 0 }) height!: number

  hasTransition = false

  created() {
    document.addEventListener('keyup', this.escapeHandler)
  }

  destroyed() {
    document.removeEventListener('keyup', this.escapeHandler)
  }

  escapeHandler({ which }: UIEvent): void {
    if (which === KeyCode.esc && this.show) {
      this.$emit('close')
    }
  }

  get dialogStyle() {
    return {
      width: `${this.width}px`,
      height: `${this.height}px`,
      transition: this.hasTransition ? 'height .15s ease-out' : 'none',
    }
  }

  @Watch('show')
  onShowChange(val: boolean) {
    setTimeout(() => {
      this.hasTransition = val
    }, 500)
  }
}
